import asoprof from "./asoprof";
import coramprof from "./coramprof";

// Para agregar un torneo: crear su archivo de configuración y registrarlo aquí.
const tournaments = { asoprof, coramprof };

// Torneo activo, elegido en build con REACT_APP_TOURNAMENT. Sin valor usa ASOPROF.
const id = process.env.REACT_APP_TOURNAMENT || "asoprof";
const tournament = tournaments[id];

if (!tournament) {
  throw new Error(
    `REACT_APP_TOURNAMENT="${id}" no es válido. Opciones: ${Object.keys(tournaments).join(", ")}`
  );
}

export default tournament;
